import React, { useEffect } from 'react';
import { AdResultMobile, AdResultPC, AdResultWrap } from '@/components/features/adv/AdResult/styles';


const adUnitsResultConfigs = { // [Desktop] Результат сверху
    "adfox_155903486431391799": {
        hb: [
            {
                "code": "adfox_155903486431391799",
                "codeType": "combo",
                "sizes": [
                    [728,90]
                ],
                "bids": [
                    {
                        "bidder": "betweenDigital",
                        "params": {
                            "placementId": "3142985"
                        }
                    },
                    {
                        "bidder": "buzzoola",
                        "params": {
                            "placementId": "1221639",
                            "sendTargetRef": true
                        }
                    },
                    {
                        "bidder": "gnezdo",
                        "params": {
                            "placementId": "205863"
                        }
                    },
                    {
                        "bidder": "sape",
                        "params": {
                            "placementId": "871374"
                        }
                    },
                    {
                        "bidder": "myTarget",
                        "params": {
                            "placementId": "1685626"
                        }
                    }
                    // ,{
                    //     "bidder": "adriver",
                    //     "params": {
                    //         "placementId": "112:testometrika_inpage"
                    //     }
                    // }
                    // ,{
                    //     "bidder": "adfox_adtech",
                    //     "params": {
                    //         p1: 'crttv',
                    //         p2: 'gdog'
                    //     }
                    // }
                ]
            }
        ],
        createParams: {
            ownerId: 285496,
            containerId: 'adfox_155903486431391799',
            params: {
                pp: 'g',
                ps: 'dhvq',
                p2: 'gkpq',
                puid1: '',
                'partner-stat-id': ''
            }
        }
    },
    "adfox_155903579397023384": {  // [Mobile] В Тесте
        hb: [
            { // [Mobile] Результат сверху
                "code": "adfox_155903579397023384",
                "codeType": "combo",
                "sizes": [
                    [320,250]
                    // [640,480]
                ],
                "bids": [
                    {
                        "bidder": "betweenDigital",
                        "params": {
                            "placementId": "3142986"
                        }
                    },

                    {
                        "bidder": "buzzoola",
                        "params": {
                            "placementId": "1221638",
                            "sendTargetRef": true
                        }
                    },
                    {
                        "bidder": "gnezdo",
                        "params": {
                            "placementId": "205863"
                        }
                    },
                    {
                        "bidder": "sape",
                        "params": {
                            "placementId": "871376"
                        }
                    },
                    {
                        "bidder": "myTarget",
                        "params": {
                            "placementId": "1685618"
                        }
                    }
                    // ,{
                    //     "bidder": "adriver",
                    //     "params": {
                    //         "placementId": "112:testometrika_inpage"
                    //     }
                    // }
                    // ,{
                    //     "bidder": "adfox_adtech",
                    //     "params": {
                    //         p1: 'crttw',
                    //         p2: 'gcfq'
                    //     }
                    // }
                ]
            }
        ],
        createParams: {
            ownerId: 285496,
            containerId: 'adfox_155903579397023384',
            params: {
                pp: 'g',
                ps: 'dhvq',
                p2: 'gkpu',
                puid1: '',
                'partner-stat-id': ''
            }
        }
    }
}

const createAdfoxBlock = (blockId: string, testIdString: string, configParams: any) => {
    const config = configParams[blockId];
    if (!config) {
        console.error(`Конфигурация для контейнера ${blockId} не найдена`);
        return;
    }

    // Уничтожаем существующий рекламный блок перед созданием нового
    // todo Uncaught (in promise) undefined
    window.Ya.adfoxCode.destroy(blockId);

    // Запрашиваем ставки
    window.Ya.headerBidding.pushAdUnits(config.hb);

    // Создаем рекламный блок
    window.yaContextCb.push(() => {
        config.createParams.params.puid1 = testIdString;
        config.createParams.params['partner-stat-id'] = testIdString;
        window.Ya.adfoxCode.create(config.createParams);
    });
};

export interface AdfoxResultProps {
    testId?: number;
    isDesktop: boolean | undefined;
}

const AdfoxResult: React.FC<AdfoxResultProps> = ({ testId, isDesktop }) => {
    // Определяем активный ID контейнера в зависимости от типа устройства
    const activeContainerId = isDesktop
        ? "adfox_155903486431391799"
        : "adfox_155903579397023384";

    useEffect(() => {
        const idTestString = testId ? testId.toString() : '0';

        // Функция инициализации рекламы
        const initializeAds = () => {
            createAdfoxBlock(activeContainerId, idTestString, adUnitsResultConfigs);
        };

        // Проверяем доступность API Яндекса
        if (window.Ya && window.Ya.adfoxCode && window.Ya.adfoxCode.hbCallbacks) {
            window.Ya.adfoxCode.hbCallbacks.push(initializeAds);
        }

        // Функция очистки при размонтировании компонента
        return () => {
            // Уничтожаем блок при размонтировании компонента
            if (window.Ya && window.Ya.adfoxCode && window.Ya.adfoxCode.destroy) {
                try {
                    window.Ya.adfoxCode.destroy(activeContainerId);
                    // console.log(`Удален блок при размонтировании: ${activeContainerId}`);
                } catch (error) {
                    console.warn(`Ошибка при удалении блока ${activeContainerId}:`, error);
                }
            }
        };
    }, [testId, isDesktop, activeContainerId]);

    // Рендерим только тот контейнер, который соответствует типу устройства
    return (
        <AdResultWrap>
            {isDesktop ? (
                <AdResultPC id="adfox_155903486431391799"></AdResultPC>
            ) : (
                <AdResultMobile id="adfox_155903579397023384"></AdResultMobile>
            )}
        </AdResultWrap>
    );
};

export default AdfoxResult;